module.exports = "/_next/static/images/unlockalt-447601eb19e8eb6f8f85eb5556f87a12.svg";